import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { StateModel } from '../../redux/store';
import { connect } from 'react-redux';

interface PrivateRouteProps {
  layout: any;
  exact?: any;
  path: string;
  configLoaded: boolean;
  isAuthenticated: boolean;
}

const PrivateRoute = ({
  layout: Layout,
  configLoaded,
  ...rest
}: PrivateRouteProps) => {
  return (
    <Route
      {...rest}
      render={props =>
        configLoaded ? <Layout {...props} /> : <Redirect to='/' />
      }
    />
  );
};

const mapStateToProps = (state: StateModel) => ({
  isAuthenticated: !!state.Auth.accessToken,
  configLoaded: state.Config.loaded,
});

export default connect(mapStateToProps, {})(PrivateRoute);
